
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob03:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M122.639 60.4736C143.148 95.2357 100.556 128 66.7391 128C32.9217 128 -1.6958 120.781 0.0644151 66.9466C1.21122 31.5185 21.8537 22.0888 56.0978 4.13502C90.3419 -13.8187 105.09 30.7194 122.639 60.4736Z" fill="#0C0D0D"/>
</svg>

  }
  
